import FirmwaresPage from './FirmwaresGroupsPage';

export default FirmwaresPage;
